import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import * as _ from "lodash";
import {DepotModel} from "../../models/depot.model";
import {DepotsComponentStore} from "../../state/depots-component.store";
import {PanelService} from "../../../../commons/angular/services/panel.service";
import * as angular from "angular";
import {DepotSelectListComponent} from "../depot-select-list/depot-select-list.component";
import {ButtonSizeType} from "../../../../commons/types/button-size.type";

require('./depot-select.scss');
@Component({
  standalone: false,
  selector: 'app-depot-select',
  templateUrl: './depot-select.html',
  providers: [DepotsComponentStore],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DepotSelectComponent implements OnInit {

  @Input() branchIds: any[];
  @Input() ngPlaceholder: any;
  @Input() excludeIds: any;
  @Input() isDisabled: any;
  @Input() isRequired: boolean;
  @Input() event: any;
  @Input() buttonSize: ButtonSizeType =ButtonSizeType.md;
  @Input() excludedDepotIds: string[] = [];
  @Output() onChange = new EventEmitter<{depot: DepotModel | null}>();

  @ViewChild('inputRef', {static: true}) inputRef: ElementRef;

  public selectedDepot: DepotModel;
  public selectedText: string = '';

  constructor(@Inject(PanelService) private panelService: PanelService,
              @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
              @Inject(DepotsComponentStore) private depotsStore: DepotsComponentStore,
              @Inject('$timeout') private $timeout) {
  }

  ngOnInit() {
    this._setSelectedText();
  }

  onResetFilter() {
    this.onChange.emit({depot: null});
  }

  onShowPanel(event) {
    if (!!this.isDisabled) {
      return;
    }

    const panel = this.panelService.open(DepotSelectListComponent,
      this.event ?? event, {
      excludeIds: this.excludeIds,
      branchIds: this.branchIds,
      ngPlaceholder: this.ngPlaceholder,
      buttonSize: this.buttonSize
    }, {
      position: {
        originX: 'center',
        originY: 'center',
        overlayX: 'start',
        overlayY: 'top'
      },
      height: 300,
      width: 260
    });

    if (panel) {
      panel.afterClose$.subscribe((data) => {
        this.selectedDepot = data?.depot ? angular.copy(data.depot) : null;
        this._setSelectedText();
        this.onChange.emit({depot: this.selectedDepot});
      })
    }
  }

  private _setSelectedText() {
    this.selectedText = this.selectedDepot?.name ?? `Select Depot`;
  }


}
